export default __webpack_public_path__ + "static/media/hot-2.cef000b4.png";